(function () {
  var scrollers = document.querySelectorAll('.creator-wall__scroller');

  scrollers.forEach(function (scroller) {
    var videos = scroller.querySelectorAll('video');
    if (!videos.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function () {
              // Autoplay can be blocked silently on some browsers; safe to ignore.
            });
          } else {
            video.pause();
          }
        });
      },
      { root: null, threshold: 0.6 }
    );

    videos.forEach(function (video) {
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      observer.observe(video);
    });
  });
})();
